// Using `||` instead of `??` to treat empty strings ('') as undefined.
/** Returns the string, or `undefined` if it is empty, `null` or `undefined`. */
export function getStringOrUndefined(string: string | null | undefined): string | undefined {
  return string || undefined;
}

/** Returns the trimmed string, or `null` if it is blank, `null` or `undefined`. */
export function trimOrNull(value?: string | null): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}
